export default "__VITE_ASSET__B6v4Ek5F__"